/**
 * Performance optimizations for Dermalogica-CH Shopify store
 * This script helps reduce Total Blocking Time by:
 * 1. Prioritizing critical resources
 * 2. Deferring non-critical JavaScript
 * 3. Optimizing third-party script loading
 */

// Resource hints for critical domains
function addResourceHints() {
  const domains = [
    'www.googletagmanager.com',
    'cdn.shopify.com',
    'cdnjs.cloudflare.com',
    'load.sumome.com',
    'widget-v4.tidiochat.com'
  ];
  
  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = `https://${domain}`;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}

// Function to defer non-critical scripts
function deferNonCriticalScripts() {
  // Check if we're on the right page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeferredLoading);
  } else {
    initDeferredLoading();
  }

  function initDeferredLoading() {
    // Delay load of non-critical third-party scripts
    window.addEventListener('load', () => {
      setTimeout(() => {
        loadDeferredScripts();
      }, 1000); // 1 second delay after window load
    });
  }

  function loadDeferredScripts() {
    // Add any deferred script loading logic here
  }
}

// Init performance optimizations
addResourceHints();
deferNonCriticalScripts();

// Optimize third-party script loading via dynamic insertion
window.optimizeScriptLoading = function(url, async = true, defer = true, callback) {
  const script = document.createElement('script');
  script.src = url;
  if (async) script.async = true;
  if (defer) script.defer = true;
  
  if (callback && typeof callback === 'function') {
    script.onload = callback;
  }
  
  document.body.appendChild(script);
  return script;
}; 